import React from "react";
import { connect } from 'react-redux';

import { scaleTime } from "d3-scale";
import { csv } from "d3-fetch";
import { Dropdown, MultiSelect } from 'carbon-components-react'
import { timeParse } from "d3-time-format";

// Redux machinery
import { setSelectedRoute, setMaxTrips, setRouteData, setSelectedStations } from '../store/actions';
import { explorerSelector } from '../store/reducers';

import { xBounds } from './marey-chart';

// Other app specifics
import { type_stations, type_stops, is_valid_time } from "./render-marey-chart";
import MareyChart from './marey-chart'; // Charles Ibry?

import { ROUTES_LIST } from '../constants';

const getRouteById = route_id => ROUTES_LIST.find(
  route => route.route_id === route_id
);


export const BASE_URL = `${process.env.PUBLIC_URL}/datasets`;
const getStationsAndStops = (route_id) => {
  return Promise.all([
    csv(`${BASE_URL}/route_${route_id}_stations.csv`),
    csv(`${BASE_URL}/route_${route_id}_stoptimes.csv`)
  ]).then(([stations, stop_times]) => {

    // Long series: 51k!
    // Post-process stops and stations
    const all_stops = stop_times
      .map(type_stops)
      .filter(d => is_valid_time(d.arrival_time))
      .slice(0, 4000); // Keep it light for debugging, remove throttle later
    const all_stations = stations.map(type_stations);
    return {
      all_stops,
      all_stations
    }
  });
}

// Data exploration page
class Explorer extends React.Component {
  handleMaxTripsChange = e => {
    const maxTrips = +e.target.value;
    // TODO: higher quality input data validation
    if (isNaN(maxTrips)) {
      return;
    }
    this.props.setMaxTrips(maxTrips);
  };

  handleRouteToggle = e => {
    const {
      selectedItem: { route_id }
    } = e; // note this is a string
    this.props.setSelectedRoute(route_id);
  };

  handleStationSelection = e => {
    this.props.setSelectedStations(e.selectedItems);
  };

  stationToString = (station) => {
    return `${station.stop_id} - ${station.name}`
  }

  fetchData() {
    getStationsAndStops(this.props.selectedRoute).then(
      ({ all_stops, all_stations }) => {
        this.props.setRouteData(all_stops, all_stations);
      }
    );
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedRoute === prevProps.selectedRoute) {
      return;
    }
    this.fetchData();
  }

  render() {
    const currentRoute = getRouteById(this.props.selectedRoute);

    const xScale = scaleTime()
      .range(xBounds)
      .domain(this.props.timeRange);

    // stay fixed - TODO: refactor this part out
    const inputTimeParse = timeParse("%H:%M:%S");
    const xScaleAxis = scaleTime()
      .domain([inputTimeParse("03:50:00"), inputTimeParse("23:59:59")])
      .range(xBounds);

    return (
      <div className="container">
        <h1 className="page-title">
          Metro-North Marey: {currentRoute.label} Line
        </h1>
        <MareyChart
          stations={this.props.stations}
          stopsByTrip={this.props.stopsByTrip}
          xScale={xScale}
          xScaleAxis={xScaleAxis}
        />
        <Dropdown

          titleText={"Select one of the 6 MetroNorth Train Lines"}
          items={ROUTES_LIST}
          initialSelectedItem={currentRoute}
          onChange={this.handleRouteToggle}
          label="route-dropdown"
          id="marey-dropdown"
        />
        <MultiSelect.Filterable
          items={this.props.stations}
          initialSelectedItems={this.props.stations}
          itemToString={this.stationToString}
          placeholder={"Type to filter stations"}
          titleText={
            "Select trips by station. By default, all stations are displayed."
          }
          onChange={this.handleStationSelection}
          id="station-dropdown"
        />
        {/* Idea: put a minimap below to zoom into time slices */}
        {/* <form id="basicForm" style={{marginTop: '50px'}}>
          <input
            type="text"
            value={this.state.max_trips}
            id="max_trips"
            onChange={throttle(this.handleMaxTripsChange, 800)}
          />
        </form> */}
        <p style={{ marginTop: "20px" }}>
          Developed by Cameron Yick for the June DVS NYC Meetup. Slides{" "}
          <a href="https://slides.com/cameronyick/metronorth-train-viz" target="_blank" rel="noreferrer noopener">
            here
          </a>.
        </p>
      </div>
    );
  }
}

export default connect(
  explorerSelector,
  {
    // data setters
    setSelectedRoute,
    setMaxTrips,
    setRouteData, // simplify - assume that one can't make sense without the other
    setSelectedStations
  }
)(Explorer);
